import React, { Component } from "react";
import Modal from "react-modal";

class ModalConditions extends Component {
  state = {};

  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    if (this.props.open === false) {
      return <React.Fragment />;
    }

    return (
      <Modal className="follow-views" isOpen={this.props.open}>
        <div className="follow-return" onClick={this.handleCloseView} />
        <div
          className="follow-view modal-media center media_v2 max_width_500"
          style={{ maxWidth: "484px" }}
        >
          <div style={{ position: "relative" }}>
            <label className="media_v2_label media_image">
              {this.props.text}
            </label>
          </div>
        </div>
      </Modal>
    );
  }

  handleCloseView = event => {
    event.preventDefault();
    this.props.handleCloseView();
  };
}

export default ModalConditions;



// WEBPACK FOOTER //
// ./src/components/list/interface/modal/modal_conditions.jsx